import Link from "next/link";
import { Fragment } from "react";

interface FooterCopyProps {
  policyLinks?: { label?: string; link?: string }[];
}

export const FooterCopy = ({ policyLinks }: FooterCopyProps) => {
  return (
    <div className="container pt-6 md:pt-14 pb-0 ">
      <div className="flex flex-col md:flex-row gap-10 text-foreground">
        <div className="flex flex-col md:flex-row gap-2 md:gap-1 items-center justify-center max-w-[600px]">
          <p className="paragraph-sm">© 2008 – {new Date().getFullYear()} Octet Finance.</p>
          <p className="paragraph-sm">All Rights Reserved.</p>
        </div>
        <div className="flex flex-row gap-4 items-center justify-center md:justify-end flex-1 text-muted-foreground">
          {policyLinks?.map((link, index) => (
            <Fragment key={index}>  
              <Link href={link.link ?? ""} className="paragraph-sm">
                {link.label}
              </Link>
              {index < policyLinks.length - 1 && "|"}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
